import { createFileRoute } from '@tanstack/react-router';
import { AGGREGATE_NAMES } from 'cpool-constants';
import { schemaUserResolver_List } from 'cpool-tables/backend-resolvers';

import { ROUTE_ROLES } from '~/features/auth/constants/routeRoles';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import { userListSearchSchema } from '~/features/userManagement/schemas/SchemaUserListSearch';
import { getQueryOptions } from '~/queryUtils/getQueryOptions';

const userListQueryOptions = getQueryOptions({
    aggregateName: AGGREGATE_NAMES.USER,
    resolverName: 'list',
    schema: schemaUserResolver_List,
});

export const Route = createFileRoute('/_app/management/users/')({
    beforeLoad: ({ location }) => {
        authoriseUser([...ROUTE_ROLES.USER_MANAGEMENT], location);
        const content = 'ROUTE_TITLE.USER_MANAGEMENT';
        return {
            meta: [
                {
                    content,
                    name: 'description',
                },
                {
                    content,
                    name: 'title',
                },
            ],
        };
    },
    loader: ({ context }) => context.queryClient.ensureQueryData(userListQueryOptions),
    validateSearch: userListSearchSchema,
});
